export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  views: number;
  isHot?: boolean;
  isNew?: boolean;
  tags: string[];
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '网红爆料',
    slug: 'wanghong-baoliao',
    description: '全网最劲爆的网红瓜，第一时间吃瓜不迷路',
    icon: 'ri-fire-line',
    articleCount: 128,
  },
  {
    id: '2',
    name: '明星八卦',
    slug: 'mingxing-bagua',
    description: '娱乐圈内幕、明星恋情、绯闻爆料一网打尽',
    icon: 'ri-star-line',
    articleCount: 96,
  },
  {
    id: '3',
    name: '吃瓜现场',
    slug: 'chigua-xianchang',
    description: '还原最真实的事件现场，带你看懂来龙去脉',
    icon: 'ri-eye-line',
    articleCount: 84,
  },
  {
    id: '4',
    name: '聊天记录',
    slug: 'liaotian-jilu',
    description: '曝光最劲爆的聊天截图，真相只有一个',
    icon: 'ri-chat-1-line',
    articleCount: 72,
  },
  {
    id: '5',
    name: '视频爆料',
    slug: 'shipin-baoliao',
    description: '高清视频还原事件真相，眼见为实',
    icon: 'ri-video-line',
    articleCount: 65,
  },
  {
    id: '6',
    name: '奇闻趣事',
    slug: 'qiwen-qushi',
    description: '网络奇闻、猎奇趣事，让你大开眼界',
    icon: 'ri-magic-line',
    articleCount: 53,
  },
];